var _defs, _g, _path, _circle, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconC2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.96,
    height: 64.96,
    viewBox: "0 0 64.96 64.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".xa{fill:#fff;stroke:#0a53a6;stroke-width:2px;}.xb{fill:#50b848;}.xc{fill:#0a53a6;}.xd{stroke:none;}.xe{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "xa"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "xd",
    cx: 32.48,
    cy: 32.48,
    r: 32.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "xe",
    cx: 32.48,
    cy: 32.48,
    r: 31.48
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "xb",
    d: "M0-.456a30.856,30.856,0,0,1,6.233-4.8c3.005-1.55,2.776,3.2,5.418,4.8s1.967,2.7-.946,3.6S0,3.149,0,3.149Z",
    transform: "translate(26.831 19.446)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "xb",
    cx: 2.471,
    cy: 2.471,
    r: 2.471,
    transform: "translate(40.953 29.656)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "xc",
    d: "M4528.382,3093.372a2.946,2.946,0,1,0-2.946-2.945,2.949,2.949,0,0,0,2.946,2.945m0-4.346a1.4,1.4,0,1,1-1.4,1.4,1.4,1.4,0,0,1,1.4-1.4",
    transform: "translate(-4484.81 -3058.472)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "xc",
    d: "M4355.363,2945.266h-5.293v-4.247a2.3,2.3,0,0,0-2.3-2.3h-3.4a3.984,3.984,0,0,0-3.094-2.864.543.543,0,0,1-.411-.487,2.937,2.937,0,0,0-2.879-2.886h-.764c-.59,0-2.54.208-2.888,2.88a.551.551,0,0,1-.408.492,4.114,4.114,0,0,0-3.193,2.854h-3.289a2.3,2.3,0,0,0-2.3,2.3v26.447a2.3,2.3,0,0,0,2.3,2.3h20.32a2.3,2.3,0,0,0,2.3-2.3v-6.42h5.3a.773.773,0,0,0,.773-.773v-14.224a.773.773,0,0,0-.773-.773m-23.382-5.354a.03.03,0,0,0,0-.009c.346-1.515,1.048-2.319,2.214-2.53a2.094,2.094,0,0,0,1.662-1.807c.132-1.022.589-1.54,1.356-1.54h.764c.428,0,1.171.2,1.346,1.532a2.069,2.069,0,0,0,1.662,1.814c1.445.271,1.846,1.452,2.105,2.535a7.327,7.327,0,0,1,.066.761l-11.248.009c.022-.362.048-.667.07-.766m16.533,27.543a.757.757,0,0,1-.756.756h-20.32a.757.757,0,0,1-.756-.756v-26.447a.757.757,0,0,1,.756-.756h2.953c-.034.426-.054.908-.064,1.171a.773.773,0,0,0,.772.8h0l12.866-.01a.773.773,0,0,0,.772-.8c-.007-.258-.025-.733-.056-1.156h3.086a.757.757,0,0,1,.756.756v4.247h-7.386a.773.773,0,0,0-.772.773v14.224a.773.773,0,0,0,.772.773h7.375Zm-3.544-7.966V2958a2.021,2.021,0,0,1,1.8-1.873h2.948a2.021,2.021,0,0,1,1.8,1.873v1.49Zm9.621,0h-1.522V2958a3.566,3.566,0,0,0-3.348-3.418h-2.948a3.561,3.561,0,0,0-3.347,3.418v1.49h-1.513v-12.678h12.679Z",
    transform: "translate(-4304.66 -2919.064)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconC2);
export default __webpack_public_path__ + "static/media/icon-c-2.075faa8b.svg";
export { ForwardRef as ReactComponent };